import Vue from "vue";
import VueGtm from "@gtm-support/vue2-gtm";
import router from "@/router";

Vue.use(VueGtm, {
  id: "GTM-NKTBPL5",
  defer: false,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
});
